import * as React from 'react';
import { connect } from 'react-redux';
import { IChannelCareAppState, ILoadCompanyRequest } from '@telstra-connect/channel-care/state';
import './style.less';
import { State as LoginState } from '@telstra-connect/login';
import { loadCasesCCD } from '@telstra-connect/channel-care/methods/load-cases-int';
import EnquiryListTabView from '../enquiry-list-tabs/index'
import { Data, ProfileIdentifier } from '@telstra-connect/utils';
import { ICustomerProfileClientState, ICustomerProfileRequest } from '@telstra-connect/channel-care/state/token-state';
import { Application } from '@channel-care';
import { Components, Links } from '@telstra-connect/channel-care/activity-tracking-int';
import { updateCompanyId } from '@telstra-connect/channel-care/methods/update-company-id';
import { loadCompanyMultiCidn } from '@telstra-connect/channel-care/methods/load-company-multi-cidn';
import global, { TransactionType } from '@applications/global';
import { requestFinished } from '@telstra-connect/utils/data';

interface IListCasesOwnProps {
    onTryAgain: () => void;
    unifiedTrackView?: boolean;
    cidn?: string;
    updatedCompanyId: string;
}

interface IListCasesDispatchProps {
    loadCasesCCD: (type: string, cidn: string) => void;
    updateCompanyId: (selectedCompanyId: string) => void;
    loadCompanyMultiCidn: () => void;
}
interface IListCasesStateProps {
    user: LoginState.IUserState;
    companyMultiCidn: ILoadCompanyRequest;
    customerProfile?: ICustomerProfileRequest;
}

interface IUnifiedTrackViewOwnState {
    activeTab: string;
    selectedCompanyId: string;
}

type ListCasesProps =
    IListCasesOwnProps &
    IListCasesStateProps &
    IListCasesDispatchProps;

class ListCasesFilterComponent extends React.Component<ListCasesProps, IUnifiedTrackViewOwnState> {

    private isMultiEntitySupportEnquiries = true;
    constructor(props: ListCasesProps) {
        super(props);
        this.state = {
            activeTab: 'Order enquiry',
            selectedCompanyId: null,
        }
        const userProps = props.user;
        const isStaffUser = props.customerProfile?.data?.profile === Data.UserType.staffUser;
        this.isMultiEntitySupportEnquiries = isStaffUser ? false : this.isMultiEntitySupportEnquiries;
    }
    public componentDidMount() {
        const tNps = global.applications['Channel Care'].TEDIG3343TransactionalNps || false;
        if (this.isMultiEntitySupportEnquiries
            && !requestFinished(this.props.companyMultiCidn)) {
            this.props.loadCompanyMultiCidn();
        }
    }

    public componentDidUpdate(prevProps) {
        const x = prevProps.updatedCompanyId !== this.props.updatedCompanyId;
        const selectedCompanyId: string = this.props.updatedCompanyId;
        const selectedCompanyName = this.getSelectedCompany(selectedCompanyId);
        if (selectedCompanyName && x) {
            this.setState({
                selectedCompanyId
            }, () => {
                const type = this.state.activeTab;
                this.props.loadCasesCCD(type, selectedCompanyId);
                this.props.updateCompanyId(this.state.selectedCompanyId);
            });
            Application.tracker.trackLink(Components.casesListComponent,
                Links.companyDropdown(selectedCompanyName));
        }
    }

    public render() {
        const tabState = { activeTab: this.state.activeTab }
        const showNewcompanyDropdown = global.applications['Channel Care'].showNewcompanyDropdown;

        return (
            <EnquiryListTabView
                activeTabState={tabState}
                setActiveTab={this.setActiveTab}
                unifiedTrackView={this.props.unifiedTrackView}
                onTryAgain={this.props.onTryAgain}
                cidn={showNewcompanyDropdown ? this.props.updatedCompanyId : this.props.cidn}
            />
        );
    }

    private getSelectedCompany = (companyId: string) => {
        const selectedCompanyArr = this.props.companyMultiCidn?.data?.data?.find((item) => item.cidn === companyId);
        const selectedCompanyName = selectedCompanyArr && selectedCompanyArr.name;
        return selectedCompanyName;
    }

    private setActiveTab = (tab: string) => {
        this.setState(
            {
                activeTab: tab
            }
        )
    }
};

type SubscribedState = IChannelCareAppState & ICustomerProfileClientState

const mapStateToProps = (state: SubscribedState): IListCasesStateProps => {
    return {
        user: state.user,
        companyMultiCidn: state.channelCare.companyMultiCidn,
        customerProfile: state.tokens.customerProfile,
    };
};

const mapDispatchToProps = (dispatch): IListCasesDispatchProps => {
    return {
        loadCasesCCD: (type: string, cidn: string) => dispatch(loadCasesCCD(type, cidn)),
        updateCompanyId: (selectedCompanyId: string) => dispatch(updateCompanyId(selectedCompanyId)),
        loadCompanyMultiCidn: () => dispatch(loadCompanyMultiCidn()),
    };
};

export const ListCasesFilterInt = connect<IListCasesStateProps,
IListCasesDispatchProps,
IListCasesOwnProps,
SubscribedState>
(mapStateToProps, mapDispatchToProps)(ListCasesFilterComponent);
